import { post } from "../../libs/ajax.js"
// 排单排期 v2 · 阶段3 排单审批（素材工单 menu tab wos_approval）
export default {
  // 审批列表
  getList: (data, options) => {
    return post("/work_order/scheduling/approval/list", data, options)
  },
  // 审批筛选选项
  getOptions: (data, options) => {
    return post("/work_order/scheduling/approval/options", data, options)
  },
  // 通过（真生效·单）
  approve: (data, options) => {
    return post("/work_order/scheduling/approval/approve", data, options)
  },
  // 驳回（单）
  reject: (data, options) => {
    return post("/work_order/scheduling/approval/reject", data, options)
  },
  // 批量通过（ids 逗号串或数组）
  batchApprove: (data, options) => {
    return post("/work_order/scheduling/approval/batch_approve", data, options)
  },
  // 批量驳回
  batchReject: (data, options) => {
    return post("/work_order/scheduling/approval/batch_reject", data, options)
  },
}
